import { render, staticRenderFns } from "./IconFaq.vue?vue&type=template&id=6da8667b&"
import script from "./IconFaq.vue?vue&type=script&lang=js&"
export * from "./IconFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports